module.exports = __webpack_public_path__ + "img/montage-logo.2f140d5a.png";